import { SiteLayout } from "@/components/site/SiteLayout";

/** 404 (DESIGN.md): as little text as possible, one way back. */
const NotFound = () => (
  <SiteLayout>
    <section className="pq-wrap pq-404" aria-labelledby="nf-h">
      <h1 id="nf-h" className="pq-display pq-rise">404.</h1>
      <p className="pq-lead pq-rise pq-rise-2">Esta página no existe.</p>
      <a href="/" className="pq-btn pq-btn-primary pq-rise pq-rise-3">Ir al inicio</a>
    </section>
  </SiteLayout>
);

export default NotFound;
